import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export function PageHeaderBadge({ icon, children, className }: { icon?: ReactNode; children: ReactNode; className?: string }) {
  return (
    <span className={cn('inline-flex min-w-0 items-center gap-1 [&_svg]:h-3.5 [&_svg]:w-3.5 [&_svg]:shrink-0', className)}>
      {icon}
      <span className="truncate">{children}</span>
    </span>
  )
}

interface PageHeaderProps {
  title: ReactNode
  description?: ReactNode
  badges?: ReactNode
  meta?: ReactNode
  leading?: ReactNode
  actions?: ReactNode
  compact?: boolean
  className?: string
}

export function PageHeader({ title, description, badges, meta, leading, actions, compact, className }: PageHeaderProps) {
  return (
    <div className={cn('flex flex-wrap justify-between gap-x-6', compact ? 'mb-4 items-center gap-y-3' : 'mb-6 items-start gap-y-4', className)}>
      <div className="flex min-w-[220px] flex-1 items-start gap-4">
        {leading && <div className="shrink-0">{leading}</div>}
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-x-2.5 gap-y-1.5">
            <h1 className={cn('min-w-0 max-w-full break-words font-semibold leading-tight tracking-tight', compact ? 'text-xl' : 'text-2xl')}>
              {title}
            </h1>
            {badges}
          </div>
          {description && (
            <div className={cn('max-w-prose text-muted-foreground', compact ? 'mt-0.5 text-[13px]' : 'mt-1.5 text-sm')}>{description}</div>
          )}
          {meta && <div className="mt-2.5 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-[13px] text-muted-foreground">{meta}</div>}
        </div>
      </div>
      {actions && <div className="flex w-full min-w-0 max-w-full shrink-0 flex-wrap items-center gap-2 sm:w-auto sm:justify-end">{actions}</div>}
    </div>
  )
}
